import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "million__traveler"
};
const _hoisted_2 = {
  class: "million__header"
};
const _hoisted_3 = {
  class: "why__heading"
};
const _hoisted_4 = {
  class: "trust-box"
};
const _hoisted_5 = {
  class: "img__box"
};
const _hoisted_6 = {
  class: "overlay-text"
};
const _hoisted_7 = {
  class: "trust-box"
};
const _hoisted_8 = {
  class: "img__box"
};
const _hoisted_9 = {
  class: "overlay-text"
};
const _hoisted_10 = {
  class: "trust-box"
};
const _hoisted_11 = {
  class: "img__box"
};
const _hoisted_12 = {
  class: "overlay-text"
};
const _hoisted_13 = {
  class: "trust-box"
};
const _hoisted_14 = {
  class: "img__box"
};
const _hoisted_15 = {
  class: "overlay-text"
};
const _hoisted_16 = {
  class: "trust-box"
};
const _hoisted_17 = {
  class: "img__box"
};
const _hoisted_18 = {
  class: "overlay-text"
};
const _hoisted_19 = {
  class: "trust-box"
};
const _hoisted_20 = {
  class: "img__box"
};
const _hoisted_21 = {
  class: "overlay-text"
};
const _hoisted_22 = {
  class: "trust-box"
};
const _hoisted_23 = {
  class: "img__box"
};
const _hoisted_24 = {
  class: "overlay-text"
};
const _hoisted_25 = {
  class: "trust-box"
};
const _hoisted_26 = {
  class: "img__box"
};
const _hoisted_27 = {
  class: "overlay-text"
};
const _hoisted_28 = {
  class: "trust-box"
};
const _hoisted_29 = {
  class: "img__box"
};
const _hoisted_30 = {
  class: "overlay-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloudImage = _resolveComponent("CloudImage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, [_cache[0] || (_cache[0] = _createTextVNode("Why millions of travelers ")), _createVNode(_component_CloudImage, {
    imageName: "love-it_f0iczg",
    alt: "love"
  }), _cache[1] || (_cache[1] = _createTextVNode(" G1G"))])]), _createElementVNode("ul", null, [_createElementVNode("li", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_CloudImage, {
    alt: "aeroplane",
    imageName: "aroplane_zmaph0"
  })]), _cache[3] || (_cache[3] = _createElementVNode("h5", null, "Travel insurance that works", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_CloudImage, {
    alt: "aeroplane",
    imageName: "aroplane-white_miohsc"
  }), _cache[2] || (_cache[2] = _createElementVNode("p", null, "All plans offered by G1G must pass a 72 benchmark of quality assurance. It just works.", -1))])]), _createElementVNode("li", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_CloudImage, {
    alt: "book",
    imageName: "book_in64tm"
  })]), _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Unbiased plan choices", -1)), _createElementVNode("div", _hoisted_9, [_createVNode(_component_CloudImage, {
    alt: "book",
    imageName: "book-white_yscwks"
  }), _cache[4] || (_cache[4] = _createElementVNode("p", null, "G1G licensed travel specialists are salaried only and not on commission. Here to help, not sell.", -1))])]), _createElementVNode("li", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_CloudImage, {
    alt: "measure",
    imageName: "measure_fpllon"
  })]), _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Low price guarantee", -1)), _createElementVNode("div", _hoisted_12, [_createVNode(_component_CloudImage, {
    alt: "measure",
    imageName: "measure-white_lmqd3j"
  }), _cache[6] || (_cache[6] = _createElementVNode("p", null, "G1G is committed to bringing you great value and all plans are low price guaranteed.", -1))])]), _createElementVNode("li", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_CloudImage, {
    alt: "award",
    imageName: "award_s4y6lw"
  })]), _cache[9] || (_cache[9] = _createElementVNode("h5", null, "24/7 award-winning support", -1)), _createElementVNode("div", _hoisted_15, [_createVNode(_component_CloudImage, {
    alt: "award",
    imageName: "award-white_vuxtxt"
  }), _cache[8] || (_cache[8] = _createElementVNode("p", null, " Our support team is #1 for fastest emergency response, with the lowest wait times and always open.", -1))])]), _createElementVNode("li", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_CloudImage, {
    alt: "trust",
    imageName: "trust_xwhis6"
  })]), _cache[11] || (_cache[11] = _createElementVNode("h5", null, "Trustworthy", -1)), _createElementVNode("div", _hoisted_18, [_createVNode(_component_CloudImage, {
    alt: "trust",
    imageName: "trust-white_nu1dpz"
  }), _cache[10] || (_cache[10] = _createElementVNode("p", null, "Trust is the primary principle we were founded on. Our G1G Guarantee places you first, always.", -1))])]), _createElementVNode("li", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_CloudImage, {
    alt: "mondy",
    imageName: "mondy_wc79iu"
  })]), _cache[13] || (_cache[13] = _createElementVNode("h5", null, "Money back guarantee", -1)), _createElementVNode("div", _hoisted_21, [_createVNode(_component_CloudImage, {
    alt: "mondy",
    imageName: "mondy-white_uojggd"
  }), _cache[12] || (_cache[12] = _createElementVNode("p", null, "If you're not happy, we will refund your money within the first 10 days of purchase. No questions.", -1))])]), _createElementVNode("li", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_CloudImage, {
    alt: "amb",
    imageName: "amb_xksodv"
  })]), _cache[15] || (_cache[15] = _createElementVNode("h5", null, "Genuine care", -1)), _createElementVNode("div", _hoisted_24, [_createVNode(_component_CloudImage, {
    alt: "amb",
    imageName: "amb-white_zglys2"
  }), _cache[14] || (_cache[14] = _createElementVNode("p", null, "We are all global citizens and caring for our community is the root of everything we do.", -1))])]), _createElementVNode("li", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_CloudImage, {
    alt: "adjustment",
    imageName: "adjustment_v67ds7"
  })]), _cache[17] || (_cache[17] = _createElementVNode("h5", null, "Tailored for you", -1)), _createElementVNode("div", _hoisted_27, [_createVNode(_component_CloudImage, {
    alt: "adjustment",
    imageName: "adjustment-white_adanq1"
  }), _cache[16] || (_cache[16] = _createElementVNode("p", null, "G1G filters and customizes your plan from thousands of choices to meet your exact trip needs.", -1))])]), _createElementVNode("li", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_CloudImage, {
    alt: "flash",
    imageName: "flash_r3c2ie"
  })]), _cache[19] || (_cache[19] = _createElementVNode("h5", null, "Fast", -1)), _createElementVNode("div", _hoisted_30, [_createVNode(_component_CloudImage, {
    alt: "flash",
    imageName: "flash-white_mfzms8"
  }), _cache[18] || (_cache[18] = _createElementVNode("p", null, "Everything we do is the fastest in the industry, from getting help to filing a claim.", -1))])])])]);
}